module.exports = __webpack_public_path__ + "img/photo_230620702_1.1c45e136.jpg";